import { isEmpty } from 'lodash';
import turf from '@turf/turf';

import { getURL, getMapBoxLayerName, getMapLocation } from '../api/Layers/layer-operations';

import adaptURL from './adapt-url';
import { coordinatesToXYZ } from './coordinates-to-xyz';
import getGeoJSONFromMapBox from './get-geojson-from-mapbox';
import getGeoJSONURLFromMapbox from './get-geojson-url-from-mapbox';
import loadGeoJSONFromURL from './load-geojson-from-url';
import parseGeoJSONTable from './parse-geojson-table';

/**
 * Fetches the MapBox and returns the two arrays needed for the table.
 *
 * @async
 * @param {string} layer - The MapBox layer.
 * @returns {object} An object containing the two arrays needed for the table.
 * @throws {Error} If something goes wrong.
 */
const loadMapBoxTable = async layer => {
  try {
    let geojson = {};
    let tableTitle = [];
    let tableBody = [];
    const url = adaptURL(getURL(layer));
    const { adaptedUrl, layerName } = getGeoJSONURLFromMapbox(url);
    if (!isEmpty(layerName)) {
      geojson = await loadGeoJSONFromURL(adaptedUrl);
    } else {
      const defaultMapCenter = isEmpty(getMapLocation(layer))
        ? turf.point([0, 0], { zoom: 0 })
        : getMapLocation(layer);
      const layerTileParams = coordinatesToXYZ(defaultMapCenter);
      geojson = await getGeoJSONFromMapBox({
        layerTileParams,
        mapboxLayerName: getMapBoxLayerName(layer),
        url
      });
    }
    ({ tableBody, tableTitle } = parseGeoJSONTable(geojson));
    return { tableBody, tableTitle };
  } catch (err) {
    throw new Error(err.message);
  }
};

export default loadMapBoxTable;
